import { Component, ElementRef, EventEmitter, forwardRef, HostBinding, Inject, Input, OnDestroy, OnInit, Optional, Output } from "@angular/core";
import { SortDirection } from "@app/enum/SortDirection";
import { ResponsiveService } from "@app/services/responsive.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { VTableHeaderType } from "../../../_enums/VTableHeaderType.enum";
import { VTableComponent } from "../../v-table.component";
import './v-table-header.component.scss';

@Component({
    selector: 'v-table-header',
    template: require('./v-table-header.component.html')
})
export class VTableHeader implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() type: VTableHeaderType;
    @Input() classes: string;
    @Input() allRowsSelected = false;
    @Input() sortable: boolean;
    @Input() sorted: boolean;
    @Input() sortDirection: SortDirection;
    @Input() minTableWidth: number;

    @Output() selectRows = new EventEmitter<boolean>();
    //--

    VTableHeaderType = VTableHeaderType;
    SortDirection = SortDirection;

    @HostBinding("style.display") display: string;

    private destroy$ = new Subject<void>();

    constructor(
        @Optional() @Inject(forwardRef(() => VTableComponent)) private table: VTableComponent,
        readonly el: ElementRef,
        private readonly responsiveService: ResponsiveService) {

    }

    ngOnInit(): void {
        this.setDisplay();
        this.responsiveService.currentWindowWidth.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.setDisplay();
        })
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.unsubscribe();
    }

    selectAllRows(): void {
        this.selectRows.emit(this.allRowsSelected);
    }

    //--

    private setDisplay(): void {
        if (!this.minTableWidth) {
            return;
        }

        this.display = this.responsiveService.shouldDisplayUsingMinWidth(this.minTableWidth, this.table.getWidth()) ? null : "none";
    }
}
